import { api } from "@/lib/api";

/**
 * CTO Directive #129 §P0.4 — Pilot Log client.
 *
 * Fire-and-forget operational telemetry. Never blocks or breaks the
 * living conversation; a failed report is silently dropped.
 */
const PLATFORM = typeof window !== "undefined" && window.__TAURI__ ? "exe" : "web";

export function reportPilotEvent(kind, extras = {}) {
  try {
    api.post("/me/pilot/event", { kind, platform: PLATFORM, ...extras })
      .catch(() => {});
  } catch {
    /* silent — telemetry must never hurt the experience */
  }
}

let crashHookInstalled = false;

export function installCrashReporter() {
  if (crashHookInstalled || typeof window === "undefined") return;
  crashHookInstalled = true;
  window.addEventListener("error", (e) => {
    reportPilotEvent("crash", {
      note: String(e?.message || "window error").slice(0, 280),
    });
  });
  window.addEventListener("unhandledrejection", (e) => {
    reportPilotEvent("crash", {
      note: ("promise: " + String(e?.reason?.message || e?.reason || "")).slice(0, 280),
    });
  });
}
